export default () => window.appConfig?.topHotelsReviewsAvailable;